import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.funktionsbereich-freigabe-berechtigung-rolle-entfernen-multi';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungFunktionsbereichFreigabeBerechtigungRolleEntfernenMultiEffects {

    FunktionsbereichFreigabeBerechtigungRolleEntfernenMulti$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_FUNKTIONSBEREICH_FREIGABE_BERECHTIGUNG_ROLLE_ENTFERNEN_MULTI),
        mergeMap((x: ac.PostFunktionsbereichFreigabeBerechtigungRolleEntfernenMultiAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postFunktionsbereichFreigabeBerechtigungRolleEntfernenMulti(x.rolleMultiRequest).pipe(
                map((result: any) => {
                    return new ac.PostFunktionsbereichFreigabeBerechtigungRolleEntfernenMultiErfolgreichAction(result, x.rolleMultiRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostFunktionsbereichFreigabeBerechtigungRolleEntfernenMultiFehlerAction(error, x.rolleMultiRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunktionsbereicheCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunktionsbereicheCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunktionsbereicheCommandService);
        }
        return this.service;
    }
}
